import { useEffect, useState } from "react";
import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import Logo from "../assets/logo.png";
import "../styles/navbar.css";

export default function AppNavbar() {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const isHome = location.pathname === "/";

  const handleAboutClick = () => {
    if (!isHome) {
      navigate("/");
    }
    setTimeout(
      () => {
        document
          .getElementById("about-us")
          ?.scrollIntoView({ behavior: "smooth" });
      },
      isHome ? 0 : 100
    );
  };

  const handleContactClick = () => {
    if (!isHome) {
      navigate("/");
    }
    setTimeout(
      () => {
        document
          .getElementById("contact-us")
          ?.scrollIntoView({ behavior: "smooth" });
      },
      isHome ? 0 : 100
    );
  };

  return (
    <Navbar
      expand="lg"
      fixed="top"
      className={`transition-navbar ${
        scrolled || !isHome ? "navbar-scrolled" : "navbar-transparent"
      }`}
    >
      <Container>
        <Navbar.Brand as={NavLink} to="/" className="d-flex align-items-center">
          <img
            src={Logo}
            alt="RR Shipping & Logistics"
            className="navbar-logo"
          />
        </Navbar.Brand>

        <Navbar.Toggle />

        <Navbar.Collapse>
          <Nav className="ms-auto align-items-lg-center gap-lg-3">
            <NavDropdown title="Services" id="services-dropdown">
              <NavDropdown.Item  as={NavLink} to="/services/custom-clearance">
                Custom Clearance
              </NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="/services/transportation">
                Transportation
              </NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="/services/freight-forwarding">
                Freight Forwarding
              </NavDropdown.Item>
            </NavDropdown>

            <Nav.Link onClick={handleAboutClick}>About Us</Nav.Link>

            <Nav.Link onClick={handleContactClick}>Contact</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
